const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (!prefersReducedMotion && 'IntersectionObserver' in window) {
  // Scoped to #MainContent only — header-group (nav, cart drawer, search)
  // renders as its own .shopify-section elements that open/close by click,
  // not by scrolling into view. Applying the reveal treatment to them left
  // the mobile menu stuck at opacity:0 forever, since a fixed drawer never
  // "intersects" the viewport the way a normal in-flow section does.
  const main = document.getElementById('MainContent');
  const sections = main ? main.querySelectorAll('.shopify-section') : [];

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        entry.target.classList.toggle('scroll-reveal--visible', entry.isIntersecting);
      }
    },
    { threshold: 0.12, rootMargin: '-6% 0px -6% 0px' }
  );

  for (const section of sections) {
    section.classList.add('scroll-reveal');
    observer.observe(section);
  }
} else {
  document.documentElement.classList.add('scroll-reveal-disabled');
}
